import React, { useState, useEffect } from 'react'

import server from 'server/serverController2'
import CommentForm from 'components/presenters/comment/modal/CommentForm'
import AnimatedWindow from 'components/containers/common/AnimatedWindow'
import AnimatedWindowHeader from 'components/presenters/header/AnimatedWindowHeader'

export default function EditCommentModal({
  visible,
  setVisible,
  initContent,
  type,
  commentNo,
  onUpdateComment,
}) {
  const [content, setContent] = useState('')
  const [isValid, setIsValid] = useState(false)

  //api end point
  let updateCommentEndPoint
  if (commentNo) {
    if (type === 'campaign_post') {
      updateCommentEndPoint = `campaigns/posts/comments/${commentNo}`
    }
  }

  useEffect(() => {
    if (content.length > 0) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [content])
  useEffect(() => {
    if (![null, undefined].includes(initContent)) {
      setContent(initContent)
    }
  }, [initContent])

  const updateComment = () => {
    let form = {}
    form['content'] = content
    server.putRequestData(updateCommentEndPoint, form, (res) => {
      try {
        if (res.success !== 1) {
          return
        }
        const jsonData = res.data
        const updatedItem = jsonData['updated_item'][0]

        if (onUpdateComment) {
          onUpdateComment(updatedItem)
        }
        setVisible(false)
      } catch (err) {
        setVisible(false)
        console.log(err)
      }
    })
  }
  return (
    <>
      <AnimatedWindow windowOn={visible} setWindowOn={setVisible}>
        <AnimatedWindowHeader
          title={'수정'}
          showComplete={true}
          isComplete={isValid}
          onBackBtn={() => {
            window.history.back()
            setVisible(false)
          }}
          onCompleteClick={() => {
            window.history.back()
            updateComment()
          }}
        />
        <div
          style={{
            overflowY: 'scroll',
            paddingLeft: 'calc(100vw*(17/375))',
            paddingRight: 'calc(100vw*(21/375))',
          }}
        >
          <CommentForm
            content={content}
            onChange={(value) => {
              setContent(value)
            }}
          />
        </div>
      </AnimatedWindow>
    </>
  )
}
